import React, { useEffect, useState } from 'react';
import { useRestaurant } from '../context/RestaurantContext';
import { useNavigate } from 'react-router-dom';

import { Button, Result } from 'antd';
import { IMAGE_ROOT_URL, HOTEL_ID } from '../constants';
import { useLanguage } from '../context/LanguageContext';
import landingIcon from '../assets/language-icon.svg';
import { getMenusOnly } from '../services/apiservice';
import LanguagePopup from '../components/LanguagePopup';
import { useDispatch } from 'react-redux';
import { updateMenuItems } from '../store/slices/irdSlice';

const Home = () => {
    const { restaurantDetails, loading: apploading } = useRestaurant();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [menuList, setMenulist] = React.useState([]);
    const { langList } = useLanguage();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        fetchMenusOnly();
    }, []);

    const fetchMenusOnly = async () => {
        setLoading(true);
        try {
            const ID = localStorage.getItem(HOTEL_ID);
            if (!ID) navigate('/page-not-found');
            const response = await getMenusOnly(ID);
            if (response.status === 200) {
                let menus = response.data.data || [];
                menus = menus.filter((menu) => Boolean(menu.enabled));
                dispatch(updateMenuItems([]));
                if (menus.length === 1) {
                    navigate(
                        `/menu-listing?menu_id=${menus[0].id}&view_only=${menus[0].view_only}&menu_count=1`
                    );
                } else {
                    setMenulist(menus);
                }
            }
        } catch (error) {
            setError('Something went wrong! Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const cardClickhandler = (service) => {
        navigate(
            `/menu-listing?menu_id=${service.id}&view_only=${service.view_only}&menu_count=${menuList.length}`
        );
    };

    return (
        <>
            <div className='landing-navigation border-b border-primaryBorder flex'>
                <div className='w-6 h-6'></div>
                <div className='logo-container flex justify-center items-center max-w-28'>
                    {restaurantDetails?.logo && (
                        <img
                            src={`${IMAGE_ROOT_URL}restaurant-properties/${restaurantDetails?.logo}`}
                            alt='primary'
                            className='max-h-11'
                        />
                    )}
                </div>
                {langList.length > 0 ? (
                    <div
                        className='language-selector'
                        onClick={() => setIsModalOpen(true)}
                    >
                        <img
                            src={landingIcon}
                            alt='Language'
                            className='language-icon'
                        />
                    </div>
                ) : (
                    <div className='w-6 h-6'></div>
                )}
            </div>
            <div className=' flex flex-col w-full relative gap-2 p-2'>
                {loading || apploading ? (
                    <LoadingSkelton />
                ) : error ? (
                    <p>error</p>
                ) : menuList?.length === 0 ? (
                    <Result
                        status='error'
                        subTitle='Menu not available at the moment!'
                        extra={
                            <Button
                                type='primary'
                                onClick={() => window.location.reload()}
                            >
                                Reload
                            </Button>
                        }
                    />
                ) : (
                    menuList?.map((service) => (
                        <ServiceCard
                            key={service.id}
                            service={service}
                            cardClickhandler={cardClickhandler}
                        />
                    ))
                )}
            </div>
            {isModalOpen && (
                <LanguagePopup
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />
            )}
        </>
    );
};

export default Home;

const ServiceCard = (props) => {
    const { service = {}, cardClickhandler } = props;

    return (
        <div
            key={service.id}
            className={`service ${service.size_type} ${service.type} `}
            style={{
                backgroundImage: `url(${IMAGE_ROOT_URL}menus/${encodeURIComponent(
                    service.image
                )})`,
            }}
            onClick={() => cardClickhandler(service)}
        >
            <div className='service_title'>{service.name}</div>
        </div>
    );
};

// const LanguagePopup = (props) => {
//     const { setIsModalOpen, isModalOpen } = props;
//     const { langList, changeLanguage, lang } = useLanguage();
//     const [language, setlanguage] = useState(lang);

//     const onContinueClickHandler = () => {
//         changeLanguage(language, true);
//         setIsModalOpen(false);
//     };
//     return (
//         <Modal
//             title='Select language'
//             open={isModalOpen}
//             onOk={() => onContinueClickHandler()}
//             onCancel={() => setIsModalOpen(false)}
//             rootClassName='language-modal'
//             centered
//             width='18rem'
//             okText='Continue'
//             cancelButtonProps={{
//                 hidden: true,
//             }}
//         >
//             <div className='content-area'>
//                 {langList.map((item) => (
//                     <div
//                         className={
//                             'lang-card ' +
//                             (item.lang_code === language ? 'selected' : '')
//                         }
//                         onClick={() => setlanguage(item.lang_code)}
//                     >
//                         <span>{item.lang_name}</span>
//                         {item.lang_code === language && (
//                             <span>
//                                 <CheckCircleTwoTone twoToneColor='green' />
//                             </span>
//                         )}
//                     </div>
//                 ))}
//             </div>
//         </Modal>
//     );
// };

const LoadingSkelton = () => {
    return (
        <div className=' flex flex-col gap-4 overflow-hidden'>
            <div className='skeleton-loader-background'></div>
            <div className='skeleton-loader-background'></div>
            <div className='skeleton-loader-background'></div>
        </div>
    );
};
